// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"MaintenanceForm_mainContainer__LXx_a","title":"MaintenanceForm_title__fL_G3","subTitle":"MaintenanceForm_subTitle__HjFms"};